/*
  ExportOsData.jsx
  ----------------
  Interface pour exporter les données des OS.
*/

import { Card, Button, Text, Group, Loader, SimpleGrid, Container } from "@mantine/core";
import { IconDownload } from "@tabler/icons-react";
import { useState } from "react";
import { useUser } from "../tools/Context";
import { showNotification } from "@mantine/notifications";
import axios from "axios";

const hostaddress = process.env.REACT_APP_API_URL;

const downloadFromBackend = async (url, token) => {
  const fullUrl = `${hostaddress}api/${url}`;
  const response = await axios.get(fullUrl, {
    responseType: "blob",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  const cd = response.headers["content-disposition"] || "";
  let fileName = "export.xlsx";
  const match = cd.match(/filename\*?=([^;]+)/i);
  if (match) {
    const value = match[1].trim();
    if (value.toLowerCase().startsWith("utf-8''")) {
      try {
        fileName = decodeURIComponent(value.substring(7));
      } catch {
        fileName = value.substring(7);
      }
    } else {
      fileName = value.replace(/(^"|"$)/g, "");
    }
  }

  const blob = new Blob([response.data], { type: response.headers["content-type"] || "application/octet-stream" });
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.setAttribute("download", fileName || "export.xlsx");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(downloadUrl);
};

export default function ExportPage() {
  const { token } = useUser();
  const [loadingOS, setLoadingOS] = useState(false);
  const [loadingDecompte, setLoadingDecompte] = useState(false);

  const handleExport = async (endpoint, label, setLoading) => {
    setLoading(true);
    try {
      await downloadFromBackend(endpoint, token);
      showNotification({
        title: "Export réussi",
        message: `Le fichier ${label} a été téléchargé avec succès.`,
        color: "green",
      });
    } catch (error) {
      console.error(`Erreur d'export ${label}:`, error);
      showNotification({
        title: `Erreur d’export`,
        message: `Impossible de télécharger les données ${label.toLowerCase()}.`,
        color: "red",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container size="lg" mt="xl">
      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="xl">
        <Card shadow="md" padding="xl" radius="md" withBorder>
          <Group justify="space-between" mb="md">
            <Text fw={600}>Exporter les OS</Text>
          </Group>
          <Text mb="md" size="sm" color="dimmed">
            Cliquez sur le bouton ci-dessous pour générer un fichier Excel contenant les données des OS signés ou en
            cours de signature.
          </Text>
          <Button
            leftSection={loadingOS ? <Loader size="xs" /> : <IconDownload size={18} />}
            onClick={() => handleExport("export/export-os", "des OS", setLoadingOS)}
            disabled={loadingOS}
          >
            {loadingOS ? "Téléchargement..." : "Télécharger"}
          </Button>
        </Card>

        <Card shadow="md" padding="xl" radius="md" withBorder>
          <Group justify="space-between" mb="md">
            <Text fw={600}>Exporter les Décomptes</Text>
          </Group>
          <Text mb="md" size="sm" color="dimmed">
            Cliquez sur le bouton ci-dessous pour générer un fichier Excel contenant les informations des décomptes
            signés ou en cours de signature.
          </Text>
          <Button
            leftSection={loadingDecompte ? <Loader size="xs" /> : <IconDownload size={18} />}
            onClick={() => handleExport("export/export-decompte", "des décomptes", setLoadingDecompte)}
            disabled={loadingDecompte}
          >
            {loadingDecompte ? "Téléchargement..." : "Télécharger"}
          </Button>
        </Card>
      </SimpleGrid>
    </Container>
  );
}
